import { render } from "./App.vue?vue&type=template&id=5f473ba6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5f473ba6&lang=scss"

import exportComponent from "C:\\Users\\winkk\\Downloads\\交接\\20261021\\nsr-isso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__